import * as api from "./DubitoAPI";

export const DubitoSvc = new api.DubitoAPI();



// WEBPACK FOOTER //
// ./src/api/index.ts